import "./assets/css/common.css";

import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Router from "./routes/router";
import { Row, Col } from "react-bootstrap";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Spinner from "./components/Spinner";
import { useDispatch, useSelector } from "react-redux";
import Login from "./pages/Auth/Login";
import Register from "./pages/Auth/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicTrackingPage from "./pages/Shipment/PublicTrackingPage";
import { getProfile } from "./redux/reducers/authSlice";
import { getBusinessesList } from "./redux/reducers/businessSlice";
import PortalLayout from "./components/Portal/PortalLayout";
import PortalLogin from "./pages/Portal/PortalLogin";
import PortalVerifyOTP from "./pages/Portal/PortalVerifyOTP";
import PortalActivate from "./pages/Portal/PortalActivate";
import PortalDashboard from "./pages/Portal/PortalDashboard";
import PortalProducts from "./pages/Portal/PortalProducts";
import PortalProductDetail from "./pages/Portal/PortalProductDetail";
import PortalCart from "./pages/Portal/PortalCart";
import PortalCheckout from "./pages/Portal/PortalCheckout";
import PortalOrders from "./pages/Portal/PortalOrders";
import PortalOrderDetail from "./pages/Portal/PortalOrderDetail";
import PortalInvoices from "./pages/Portal/PortalInvoices";
import PortalInvoiceDetail from "./pages/Portal/PortalInvoiceDetail";
import PortalProfile from "./pages/Portal/PortalProfile";
import PortalSelectBusiness from "./pages/Portal/PortalSelectBusiness";
import JoinPortal from "./pages/public/JoinPortal";
import VerifyNotice from "./pages/Onboarding/VerifyNotice";
import VerifyEmailHandler from "./pages/Onboarding/VerifyEmailHandler";
import SetupBusiness from "./pages/Onboarding/SetupBusiness";
import "./App.css";

function App() {
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => setShowSidebar(!showSidebar);
  const closeSidebar = () => setShowSidebar(false);

  const dispatch = useDispatch();
  const { token, masterCustomerId, userDetail } = useSelector((state) => state.auth);

  useEffect(() => {
  // Fetch profile once when token exists and we don't have userDetail yet
  if (token && !userDetail) {
    dispatch(getProfile());
  }
  // Fetch businesses only after email is verified
  if (masterCustomerId && userDetail?.isVerified) {
    dispatch(getBusinessesList(masterCustomerId));
  }
}, [dispatch, token, masterCustomerId, userDetail?.isVerified, userDetail]);

  return (
    <div className="container-fluid p-0 overflow-hidden">
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/onboarding/verify-notice" element={<VerifyNotice />} />
        <Route path="/onboarding/verify-email" element={<VerifyEmailHandler />} />
        <Route path="/onboarding/setup-business" element={<SetupBusiness />} />
        <Route path="/track/:trackingCode" element={<PublicTrackingPage />} />

        {/* Portal Public Routes */}
        <Route path="/customer-side/login" element={<PortalLogin />} />
        <Route path="/customer-side/verify" element={<PortalVerifyOTP />} />
        <Route path="/customer-side/select-business" element={<PortalSelectBusiness />} />
        <Route path="/customer-side/activate/:token" element={<PortalActivate />} />
        <Route path="/join/:token" element={<JoinPortal />} />

        {/* Portal Protected Routes */}
        <Route path="/customer-side/:businessId" element={<PortalLayout />}>
          <Route path="dashboard" element={<PortalDashboard />} />
          <Route path="products" element={<PortalProducts />} />
          <Route path="products/:id" element={<PortalProductDetail />} />
          <Route path="cart" element={<PortalCart />} />
          <Route path="checkout" element={<PortalCheckout />} />
          <Route path="orders" element={<PortalOrders />} />
          <Route path="orders/:id" element={<PortalOrderDetail />} />
          <Route path="invoices" element={<PortalInvoices />} />
          <Route path="invoices/:id" element={<PortalInvoiceDetail />} />
          <Route path="profile" element={<PortalProfile />} />
        </Route>
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Row className="g-0 flex-nowrap">
                <Col xs="auto" className={`sidebar-wrapper ${showSidebar ? "show" : ""}`}>
                  <Sidebar closeSidebar={closeSidebar} />
                  {showSidebar && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
                </Col>
                <Col className="w-100">
                  <Header toggleSidebar={toggleSidebar} />
                  <main className="p-4 bg-base" style={{ height: "calc(100vh - 70px)", overflowY: "auto" }}>
                    <Router />
                  </main>
                </Col>
              </Row>
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
